import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

function ModalError(props) {
    return(
        <Dialog open={props.open}
                onClose={props.close}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{"Advertencia"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Ha ocurrido un error al procesar la solicitud
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color={"primary"} onClick={props.close}>
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ModalError;